var _path, _g, _path2, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAdddevices(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.65316 4.03477C8.68314 3.9313 7.70482 4.05938 6.78081 4.41082C5.85679 4.76227 5.00742 5.32933 4.28705 6.07572C3.56668 6.82211 2.99117 7.7314 2.59735 8.7454C2.20353 9.7594 2.00008 10.8558 2 11.9644V15.5575C2 15.6749 2.04097 15.7874 2.1139 15.8704C2.18683 15.9534 2.28574 16 2.38888 16C2.49202 16 2.59093 15.9534 2.66386 15.8704C2.73679 15.7874 2.77776 15.6749 2.77776 15.5575V12.1547C2.7597 10.3941 3.30927 8.68696 4.32252 7.35624C5.33578 6.02551 6.74246 5.16343 8.27652 4.93305C9.14866 4.81689 10.0325 4.91211 10.87 5.21243C11.7075 5.51274 12.4796 6.01137 13.1357 6.67552C13.7917 7.33966 14.3168 8.15429 14.6763 9.06584C15.0359 9.97739 15.2218 10.9652 15.2219 11.9644V15.5575C15.2219 15.6749 15.2629 15.7874 15.3358 15.8704C15.4087 15.9534 15.5077 16 15.6108 16C15.7139 16 15.8128 15.9534 15.8858 15.8704C15.9587 15.7874 15.9997 15.6749 15.9997 15.5575V12.1502C16.0165 10.1422 15.376 8.19896 14.2028 6.69881C13.0297 5.19866 11.4078 4.24901 9.65316 4.03477Z",
    fill: "currentColor"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1145_94)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.74999 10C4.49021 10 3.28204 10.5005 2.39124 11.3912C1.50044 12.282 1 13.4902 1 14.75C1 16.0098 1.50044 17.218 2.39124 18.1088C3.28204 18.9995 4.49021 19.5 5.74999 19.5C5.94779 19.5004 6.14536 19.4863 6.3411 19.4578L6.80554 19.3997V10.1003L6.3411 10.0422C6.14536 10.0137 5.94779 9.99958 5.74999 10ZM11.0278 10C10.83 9.99958 10.6324 10.0137 10.4366 10.0422L9.9722 10.1003V19.3997L10.4366 19.4578C10.6324 19.4863 10.83 19.5004 11.0278 19.5C12.2875 19.5 13.4957 18.9995 14.3865 18.1088C15.2773 17.218 15.7777 16.0098 15.7777 14.75C15.7777 13.4902 15.2773 12.282 14.3865 11.3912C13.4957 10.5005 12.2875 10 11.0278 10Z",
    fill: "currentColor"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 4.5H20.5V1.44836C20.5 1.20074 19.7476 1 19.5 1C19.2524 1 18.5 1.20074 18.5 1.44836V4.5H15.5C15.2524 4.5 15 5.25239 15 5.50001C15 5.74763 15.2524 6.5 15.5 6.5H18.5V9.5C18.5 9.74762 19.2524 10 19.5 10C19.7476 10 20.5 9.74762 20.5 9.5V6.5H23.5C23.7476 6.5 24 5.74763 24 5.50001C24 5.25239 23.7476 4.5 23.5 4.5Z",
    fill: "currentColor"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1145_94"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 11,
    fill: "white",
    transform: "translate(8 9)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdddevices);
export default __webpack_public_path__ + "static/media/add devices.23d2e4ef70a3ada8499d7f2e0e1637be.svg";
export { ForwardRef as ReactComponent };